export default __webpack_public_path__ + "static/media/balance-auto-transparency.caa4f348.md";